import React from 'react';

/**
 * Terms and Conditions component for registering an account.
 */
const TermsAndConditions = () => (
  <>
    <p>
      *I have read and agree to NBCUniversal&apos;s&nbsp;
      <a
        href="https://www.nbc.com/general/pages/terms"
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms of Use
      </a>
      &nbsp;and&nbsp;
      <a
        href=" https://www.nbcuniversal.com/privacy?intake=NBC_News"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </a>
      .
    </p>
    <p>
      I understand that TODAY and NBCUniversal may send me the latest news,
      promotions and more.
    </p>
    <p>
      NBCUniversal Profile will provide access to content from multiple
      NBCUniversal brands.
    </p>
  </>
);

export { TermsAndConditions };
